define("shared/components/shared/image", ["exports", "@ember/component", "@ember/debug", "@ember/object", "@ember/string", "@glimmer/component", "later/utils/constants", "shared/types/image", "shared/utils/platform-check", "@ember/template-factory"], function (_exports, _component, _debug, _object, _string, _component2, _constants, _image, _platformCheck, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _parseSources, _getFallbackSource;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/debug",0,"@ember/object",0,"@ember/string",0,"@glimmer/component",0,"later/utils/constants",0,"shared/types/image",0,"shared/utils/platform-check",0,"@ember/component"eaimeta@70e063a35619d71f
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.sources.length}}
    <picture class={{@wrapperClass}} data-test-id="shared-image">
  
      {{#if (gt this.sources.length 1)}}
        {{#each this.sources as |imageSource|}}
          <source
            height={{imageSource.height}}
            media={{imageSource.media}}
            sizes={{imageSource.sizes}}
            srcset={{imageSource.src}}
            type={{imageSource.type}}
            width={{imageSource.width}}
          />
        {{/each}}
      {{/if}}
      <img
        alt={{@picture.alt}}
        class={{@class}}
        src={{this.fallbackSource.src}}
        {{load-image-async this.processingImageUrl this.fallbackSource.src this.onError this.onLoad}}
        ...attributes
      />
    </picture>
  {{/if}}
  */
  {
    "id": "lGLDfkna",
    "block": "[[[41,[30,0,[\"sources\",\"length\"]],[[[1,\"  \"],[10,\"picture\"],[15,0,[30,1]],[14,\"data-test-id\",\"shared-image\"],[12],[1,\"\\n\\n\"],[41,[28,[37,1],[[30,0,[\"sources\",\"length\"]],1],null],[[[42,[28,[37,3],[[28,[37,3],[[30,0,[\"sources\"]]],null]],null],null,[[[1,\"        \"],[10,\"source\"],[15,\"height\",[30,2,[\"height\"]]],[15,\"media\",[30,2,[\"media\"]]],[15,\"sizes\",[30,2,[\"sizes\"]]],[15,\"srcset\",[30,2,[\"src\"]]],[15,\"width\",[30,2,[\"width\"]]],[15,4,[30,2,[\"type\"]]],[12],[13],[1,\"\\n\"]],[2]],null]],[]],null],[1,\"    \"],[11,\"img\"],[16,\"alt\",[30,3,[\"alt\"]]],[16,0,[30,4]],[16,\"src\",[30,0,[\"fallbackSource\",\"src\"]]],[17,5],[4,[38,4],[[30,0,[\"processingImageUrl\"]],[30,0,[\"fallbackSource\",\"src\"]],[30,0,[\"onError\"]],[30,0,[\"onLoad\"]]],null],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[\"@wrapperClass\",\"imageSource\",\"@picture\",\"@class\",\"&attrs\"],false,[\"if\",\"gt\",\"each\",\"-track-array\",\"load-image-async\"]]",
    "moduleName": "shared/components/shared/image.hbs",
    "isStrictMode": false
  });
  /**
   * @class Shared::Image
   * This component is a wrapper for the <picture> HTML element. This allows us
   * to more easily handle rendering different formats and/or dimensions of an image.
   *
   * @example Simple usage with no extra attributes. Component will
   * extract the type from the file extension
   *
   * this.imageAsset = {
   *  sources: [
   *   'assets/images/mov--schedule_a_post.jpg',
   *   'assets/images/mov--schedule_a_post.webp',
   *   'assets/images/mov--schedule_a_post.avif',
   *  ],
   *  alt: 'caption'
   * };
   *
   * <Shared::Image @picture={{this.imageAsset}} />
   *
   * @example Simple usage with asynchronous loading and placeholder iamge.
   * @example Simple usage with asynchronous loading and placeholder image.
   * this.imageAsset = {
   *  sources: [
   *   'assets/images/mov--schedule_a_post.jpg',
   *  ],
   *  alt: 'caption'
   * };
   *
   * <Shared::Image @picture={{this.imageAsset}} @processingImageUrl="https://image-cdn.later.com/static/img--imageprocessing.gif" />
   *
   * @example Usage with media query and sizes attributes
   * this.imageAsset = {
   *  sources: [
   *    {
   *      src: 'assets/images/mov--landscape--schedule_a_post.jpg',
   *      type: ImageMimeType.Jpg,
   *      media: "(min-width: 1000px)",
   *      width:"1000"
   *      height: "400"
   *    },
   *    {
   *      src: 'assets/images/mov--landscape--schedule_a_post.avif',
   *      type: ImageMimeType.Avif, media: "(min-width: 1000px)",
   *      width:"1000",
   *      height: "400"
   *    },
   *    {
   *      src: 'assets/images/mov--square--schedule_a_post.jpg',
   *      type: ImageMimeType.Jpg,
   *      media: "(min-width: 400)",
   *      width:"400"
   *      height: "400"
   *    },
   *    {
   *      src: 'assets/images/mov--square--schedule_a_post.avif',
   *      type: ImageMimeType.Avif,
   *      media: "(min-width: 400)",
   *      width:"400",
   *      height: "400"
   *    },
   *  ],
   *  alt: 'caption'
   * };
   *
   * <Shared::Image @picture={{this.imageAsset}} />
   *
   **/

  // Note: Ranked based on best support on all devices and browsers
  const RANKED_MIME_TYPE = [_image.MimeType.Png, _image.MimeType.Jpg, _image.MimeType.Svg, _image.MimeType.Gif, _image.MimeType.Webp, _image.MimeType.Avif];
  let ImageComponent = _exports.default = (_class = (_parseSources = /*#__PURE__*/new WeakSet(), _getFallbackSource = /*#__PURE__*/new WeakSet(), class ImageComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _classPrivateMethodInitSpec(this, _getFallbackSource);
      _classPrivateMethodInitSpec(this, _parseSources);
      (false && !(typeof this.args.picture === 'object') && (0, _debug.assert)('Must provide `picture` object', typeof this.args.picture === 'object'));
    }
    get isIos() {
      return (0, _platformCheck.isIos)(navigator);
    }
    get sources() {
      const sources = _classPrivateMethodGet(this, _parseSources, _parseSources2).call(this, Array.isArray(this.args.picture.sources) ? this.args.picture.sources : [this.args.picture.sources]);
      // Note: iOS bug, skip AVIF for iOS.
      // iOS 16.1 is supposed to support animated AVIF so it attempts to load AVIF source but fails
      // no widely supported way to detect if it's animated or not so skipping AVIF for iOS completely
      // https://bugs.webkit.org/show_bug.cgi?id=248755
      // https://bugs.webkit.org/show_bug.cgi?id=247831
      if (this.isIos) {
        return sources.filter(source => source.type !== _image.MimeType.Avif);
      }
      return sources;
    }
    get fallbackSource() {
      return _classPrivateMethodGet(this, _getFallbackSource, _getFallbackSource2).call(this, this.sources);
    }
    get processingImageUrl() {
      return this.args.processingImageUrl || _constants.DEFAULT_PROCESSING_IMAGE_URL;
    }
    onError() {
      this.args.onError?.();
    }
    onLoad() {
      this.args.onLoad?.();
    }
  }), (_applyDecoratedDescriptor(_class.prototype, "onError", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onLoad", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onLoad"), _class.prototype)), _class);
  function _parseSources2(sources) {
    const parsedSources = [];
    for (const source of sources) {
      if (typeof source === 'object') {
        parsedSources.push(source);
      } else if (typeof source === 'string') {
        const fileExtension = source.split(/[#?]/)[0].split('.').pop()?.trim();
        if (!fileExtension) {
          throw new Error('Unable to determine file extension.');
        }
        const type = _image.MimeType[(0, _string.capitalize)(fileExtension)];
        parsedSources.push({
          src: source,
          type
        });
      }
    }
    return parsedSources;
  }
  function _getFallbackSource2(sources) {
    if (sources.length === 1) {
      return sources[0];
    }
    for (const type of RANKED_MIME_TYPE) {
      for (const source of sources) {
        if (source.type === type) {
          return source;
        }
      }
    }
    (false && !(false) && (0, _debug.assert)(`Unable to find fallback media within ${sources}.`));
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ImageComponent);
});